export default "__VITE_ASSET__BrjhWDqC__"